// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
  Global
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU {
  background-color: #071c35;
  color: #ffffff;
  font-family: 'Proxima Nova', Helvetica, Arial, sans-serif;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU div,
p {
  font-family: 'Proxima Nova', Helvetica, Arial, sans-serif !important;
}

/* This is in here because it does override airframe styles specificially to match */
p {
  font-size: 14px !important;
  line-height: 1.5 !important;
}

/*
  Link
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU a {
  color: #10325b;
}

/* 
  Button
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU button {
  display: inline-block;
  background-color: var(--orange);
  border: 0 none;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  outline: 0;
  padding: 5px 30px;
}

/* 
  Button states
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU button:active,
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU button:focus,
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU button:hover {
  background-color: #81a2ca;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU button[disabled] {
  color: #cdcdcd;
  background-color: #7a8794;
  cursor: not-allowed;
  opacity: 0.65;
}

/* 
  legend
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU legend {
  border: 0 none;
  color: #ffffff;
  font-weight: normal;
  margin: inherit;
}

/* 
  Label
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU label {
  display: inherit;
  color: #2d2926; /* airframe eclipse/fgOnLight/grey80 */
  font-weight: bold;
}

/*
  Input clear button
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU label > div > button {
  border-radius: 0px 1px 1px 0px; /*to sharpen the default 2px and match the tighter inside corners of the input*/
  min-height: 34.8px; /*.8 b/c something weird's goiong on, proabbly w/ rem values, on the input height*/
  min-width: 35px;
  padding: 10px;
  top: 1px;
}

/* 
  Input of type text and email
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU input[type='tel'],
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU input[type='text'],
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU input[type='email'] {
  background-color: #a8b0b8;
  border: 1px solid #ffffff;
  color: #ffffff;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU input[type='tel']:focus,
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU input[type='text']:focus,
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU input[type='email']:focus {
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU input[type='tel'][disabled],
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU input[type='text'][disabled],
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU input[type='email'][disabled] {
  background-color: #7a8794;
  border: 1px solid #707d8a;
  color: #cdcdcd;
}

/* 
  react tel input dropdown text color
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [class*='react-tel-input'] input,
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [class*='react-tel-input'] input ~ div {
  /* important are required to override inline styles */
  border: 1px solid #ffffff !important;
  color: #ffffff !important;
  font-family: inherit !important;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [class*='react-tel-input'] input[disabled],
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [class*='react-tel-input'] input[disabled] ~ div {
  /* important are required to override inline styles */
  background-color: #7a8794 !important;
  border: 1px solid #707d8a !important;
  color: #cdcdcd !important;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [class*='react-tel-input'] input ~ div ul {
  color: #071c35;
}

/* 
  Input of type checkbox and radio
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU input:checked + div {
  border-color: #4a709d;
}

/* 
  Dropdown
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [class*='container'] [class*='control'] {
  background-color: #a8b0b8;
  border: 1px solid #ffffff;
  font-weight: 400;
  min-height: 38px;
  height: 38px;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU
  [class*='container'][disabled]
  [class*='control'][disabled] {
  background-color: #7a8794;
  border: 1px solid #707d8a;
  color: #cdcdcd;
}

/*
  disabled airframe input lables
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU div > label > div > span[disabled] {
  color: #696969;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [class*='container'] [class*='singleValue'] {
  color: #ffffff;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU div[disabled] [class*='container'] [class*='control'] {
  background-color: #7a8794;
  border: 1px solid #707d8a;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU div[disabled] [class*='container'] [class*='singleValue'] {
  color: #cdcdcd;
}
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [class*='container'] [class*='ValueContainer'] {
  height: 38px;
  padding: 0 8px;
}

/*
  Errors
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [id\$='-error'] {
  color: #c02323;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU input[aria-invalid='true'] {
  border-color: #c02323;
}

/* 
  Accordion
*/
.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [role='tablist'] {
  background-color: #84919e;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [role='tablist'] button[role='tab'] {
  background-color: #c1c7cd;
  border-radius: 3px 3px 0 0;
  color: #071c35;
  font-weight: 400;
  padding: 1rem 0.5rem;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [role='tablist']:nth-of-type(even) button[role='tab'] {
  background-color: #dfe3e6;
  border-radius: 0;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU button[role='tab'] svg[alt*='chevron'] {
  width: 24px;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU button[role='tab'] svg[alt*='chevron'] path {
  fill: #ffffff;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU button[role='tab']:hover > svg[alt*='chevron'] path {
  fill: var(--orange);
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [role='tablist'] [role='panel-content'] {
  background-color: #828e9a;
}

.src-js-components-cirium-airframe-overrides-module__airframe--WRqAM.src-js-components-cirium-airframe-overrides-module__overrides--hQIEU [aria-expanded] > [aria-hidden] {
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/cirium/airframe.overrides.module.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;EACE,yBAAyB;EACzB,cAAc;EACd,yDAAyD;AAC3D;;AAEA;;EAEE,oEAAoE;AACtE;;AAEA,oFAAoF;AACpF;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;CAEC;AACD;EACE,cAAc;AAChB;;AAEA;;CAEC;AACD;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;;CAEC;AACD;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;CAEC;AACD;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;CAEC;AACD;EACE,gBAAgB;EAChB,cAAc,EAAE,sCAAsC;EACtD,iBAAiB;AACnB;;AAEA;;CAEC;AACD;EACE,8BAA8B,EAAE,+EAA+E;EAC/G,kBAAkB,EAAE,kFAAkF;EACtG,eAAe;EACf,aAAa;EACb,QAAQ;AACV;;AAEA;;CAEC;AACD;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE;oCACkC;AACpC;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;CAEC;AACD;;EAEE,qDAAqD;EACrD,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,qDAAqD;EACrD,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;CAEC;AACD;EACE,qBAAqB;AACvB;;AAEA;;CAEC;AACD;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;CAEC;AACD;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;;CAEC;AACD;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;CAEC;AACD;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["/* \n  Global\n*/\n.airframe.overrides {\n  background-color: #071c35;\n  color: #ffffff;\n  font-family: 'Proxima Nova', Helvetica, Arial, sans-serif;\n}\n\n.airframe.overrides div,\np {\n  font-family: 'Proxima Nova', Helvetica, Arial, sans-serif !important;\n}\n\n/* This is in here because it does override airframe styles specificially to match */\np {\n  font-size: 14px !important;\n  line-height: 1.5 !important;\n}\n\n/*\n  Link\n*/\n.airframe.overrides a {\n  color: #10325b;\n}\n\n/* \n  Button\n*/\n.airframe.overrides button {\n  display: inline-block;\n  background-color: var(--orange);\n  border: 0 none;\n  border-radius: 4px;\n  color: #ffffff;\n  cursor: pointer;\n  outline: 0;\n  padding: 5px 30px;\n}\n\n/* \n  Button states\n*/\n.airframe.overrides button:active,\n.airframe.overrides button:focus,\n.airframe.overrides button:hover {\n  background-color: #81a2ca;\n}\n\n.airframe.overrides button[disabled] {\n  color: #cdcdcd;\n  background-color: #7a8794;\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n/* \n  legend\n*/\n.airframe.overrides legend {\n  border: 0 none;\n  color: #ffffff;\n  font-weight: normal;\n  margin: inherit;\n}\n\n/* \n  Label\n*/\n.airframe.overrides label {\n  display: inherit;\n  color: #2d2926; /* airframe eclipse/fgOnLight/grey80 */\n  font-weight: bold;\n}\n\n/*\n  Input clear button\n*/\n.airframe.overrides label > div > button {\n  border-radius: 0px 1px 1px 0px; /*to sharpen the default 2px and match the tighter inside corners of the input*/\n  min-height: 34.8px; /*.8 b/c something weird's goiong on, proabbly w/ rem values, on the input height*/\n  min-width: 35px;\n  padding: 10px;\n  top: 1px;\n}\n\n/* \n  Input of type text and email\n*/\n.airframe.overrides input[type='tel'],\n.airframe.overrides input[type='text'],\n.airframe.overrides input[type='email'] {\n  background-color: #a8b0b8;\n  border: 1px solid #ffffff;\n  color: #ffffff;\n}\n\n.airframe.overrides input[type='tel']:focus,\n.airframe.overrides input[type='text']:focus,\n.airframe.overrides input[type='email']:focus {\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),\n    0 0 8px rgba(102, 175, 233, 0.6);\n}\n\n.airframe.overrides input[type='tel'][disabled],\n.airframe.overrides input[type='text'][disabled],\n.airframe.overrides input[type='email'][disabled] {\n  background-color: #7a8794;\n  border: 1px solid #707d8a;\n  color: #cdcdcd;\n}\n\n/* \n  react tel input dropdown text color\n*/\n.airframe.overrides [class*='react-tel-input'] input,\n.airframe.overrides [class*='react-tel-input'] input ~ div {\n  /* important are required to override inline styles */\n  border: 1px solid #ffffff !important;\n  color: #ffffff !important;\n  font-family: inherit !important;\n}\n\n.airframe.overrides [class*='react-tel-input'] input[disabled],\n.airframe.overrides [class*='react-tel-input'] input[disabled] ~ div {\n  /* important are required to override inline styles */\n  background-color: #7a8794 !important;\n  border: 1px solid #707d8a !important;\n  color: #cdcdcd !important;\n}\n\n.airframe.overrides [class*='react-tel-input'] input ~ div ul {\n  color: #071c35;\n}\n\n/* \n  Input of type checkbox and radio\n*/\n.airframe.overrides input:checked + div {\n  border-color: #4a709d;\n}\n\n/* \n  Dropdown\n*/\n.airframe.overrides [class*='container'] [class*='control'] {\n  background-color: #a8b0b8;\n  border: 1px solid #ffffff;\n  font-weight: 400;\n  min-height: 38px;\n  height: 38px;\n}\n\n.airframe.overrides\n  [class*='container'][disabled]\n  [class*='control'][disabled] {\n  background-color: #7a8794;\n  border: 1px solid #707d8a;\n  color: #cdcdcd;\n}\n\n/*\n  disabled airframe input lables\n*/\n.airframe.overrides div > label > div > span[disabled] {\n  color: #696969;\n}\n\n.airframe.overrides [class*='container'] [class*='singleValue'] {\n  color: #ffffff;\n}\n\n.airframe.overrides div[disabled] [class*='container'] [class*='control'] {\n  background-color: #7a8794;\n  border: 1px solid #707d8a;\n}\n\n.airframe.overrides div[disabled] [class*='container'] [class*='singleValue'] {\n  color: #cdcdcd;\n}\n.airframe.overrides [class*='container'] [class*='ValueContainer'] {\n  height: 38px;\n  padding: 0 8px;\n}\n\n/*\n  Errors\n*/\n.airframe.overrides [id$='-error'] {\n  color: #c02323;\n}\n\n.airframe.overrides input[aria-invalid='true'] {\n  border-color: #c02323;\n}\n\n/* \n  Accordion\n*/\n.airframe.overrides [role='tablist'] {\n  background-color: #84919e;\n}\n\n.airframe.overrides [role='tablist'] button[role='tab'] {\n  background-color: #c1c7cd;\n  border-radius: 3px 3px 0 0;\n  color: #071c35;\n  font-weight: 400;\n  padding: 1rem 0.5rem;\n}\n\n.airframe.overrides [role='tablist']:nth-of-type(even) button[role='tab'] {\n  background-color: #dfe3e6;\n  border-radius: 0;\n}\n\n.airframe.overrides button[role='tab'] svg[alt*='chevron'] {\n  width: 24px;\n}\n\n.airframe.overrides button[role='tab'] svg[alt*='chevron'] path {\n  fill: #ffffff;\n}\n\n.airframe.overrides button[role='tab']:hover > svg[alt*='chevron'] path {\n  fill: var(--orange);\n}\n\n.airframe.overrides [role='tablist'] [role='panel-content'] {\n  background-color: #828e9a;\n}\n\n.airframe.overrides [aria-expanded] > [aria-hidden] {\n  background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"airframe": `src-js-components-cirium-airframe-overrides-module__airframe--WRqAM`,
	"overrides": `src-js-components-cirium-airframe-overrides-module__overrides--hQIEU`
};
export default ___CSS_LOADER_EXPORT___;
